import { all, call } from "redux-saga/effects";

// do not create sagas if not needed, use for async store update

import UserSaga from "./userSaga";
import ProductSaga from "./productSaga";
import OrderSaga from "./orderSaga";
import LeaderSaga from "./leaderSaga";
import CategoriesSaga from "./categoriesSaga";
import miscSaga from "./miscSaga";
import deepLinksSaga from "./deepLinks.saga";
import navSaga from "./navigation.saga";
import oldWalletSaga from "./oldWalletSaga";
import homeSaga from "./homeSaga";
import configSaga from "./configSaga";
import lglSaga from "./lglSaga";
import ccfpSaga from "./ccfpSaga";
import delayDataSaga from "./delayDataSaga";
import customerSaga from "./customerSaga";
import supportSaga from "./supportSaga";
import returnOrdersSaga from "./returnOrders.saga";
import authSaga from "./authSaga";
import vacationSaga from "./vacationSaga";
import clTaskSaga from "./clTaskSaga";
import myDeliveriesSaga from "./myDeliveries";
import clContestSaga from "./clContestSaga";
import rrdSaga from "./rrdSaga";
import brownLogisticsSaga from "./brownLogisticsSaga";
import homeWidgetSaga from "./homeWidgetSaga";
import walletSaga from "./walletSaga";
import cpDeliveryRoutesSaga from "./cpDeliveryRoutesSaga";

export function* rootSaga() {
  yield all([
    call(authSaga),
    call(UserSaga),
    call(ProductSaga),
    call(OrderSaga),
    call(LeaderSaga),
    call(CategoriesSaga),
    call(miscSaga),
    call(deepLinksSaga),
    call(navSaga),
    call(oldWalletSaga),
    call(homeWidgetSaga),
    call(homeSaga),
    call(configSaga),
    call(lglSaga),
    call(ccfpSaga),
    call(delayDataSaga),
    call(customerSaga),
    call(supportSaga),
    call(returnOrdersSaga),
    call(vacationSaga),
    call(clTaskSaga),
    call(myDeliveriesSaga),
    call(clContestSaga),
    call(rrdSaga),
    call(brownLogisticsSaga),
    call(walletSaga),
    call(cpDeliveryRoutesSaga),
  ]);
}
